import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { colors, Divider } from '@creditsights/styleguide-web';
import { CqsMetric } from '../../../../../models/RiskProducts';
import { formatCommonDate } from '../../../../../utils/dateUtils';
import styles from './CqsChartTooltipContent.module.scss';

const cx = classNames.bind(styles);

interface CqsChartTooltipContentProps {
  cqsMetric: CqsMetric;
}

const CqsChartTooltipContent = ({ cqsMetric }: CqsChartTooltipContentProps): ReactElement => {
  const renderChartMetric = (color: string, label: string, value?: string | number | null) => {
    return (
      value !== null && (
        <div className={cx('metric')}>
          <div className={cx('color-block', color)} />
          {label} <span className={cx('value')}>{value}</span>
        </div>
      )
    );
  };
  return (
    <div className={cx('body')} data-testid="cqs-tooltip-content">
      <span>{formatCommonDate(cqsMetric.calculationDate)}</span>
      <div className={cx('divider-wrapper')}>
        <Divider color={colors.tertiary700} />
      </div>
      <div className={cx('metrics')}>
        {renderChartMetric('color-cqs', 'CQS', cqsMetric.cqs)}
        {renderChartMetric('color-acr', 'ACR', cqsMetric.acr)}
      </div>
    </div>
  );
};

export default CqsChartTooltipContent;
